module.exports = __webpack_public_path__ + "static/pie-chart-9d8ffdfaa4797b43f887f8127e0095d3.png";